import { UAA, UAA_ANONYMOUS } from '@/clients'
import { laravelErrorHandler } from '@/helpers'
import { eventsConstants } from '@/helpers/eventsList'

const loginUser = async formData => {
  const { email: username, password, recaptcha: captchaToken } = formData
  const route = `users/authenticate`
  const postData = {
    username,
    password,
    captchaToken,
  }
  try {
    const {
      data: { data },
    } = await UAA.post(route, postData)
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const fetchStatus = async () => {
  const route = 'auth/state/status'
  try {
    const {
      data: { data },
    } = await UAA.get(route)
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const fetchTrackLeadAlias = async email => {
  try {
    const route = 'track-lead'
    const response = await UAA_ANONYMOUS.post(route, {
      email,
      source: 'checkout.ine.com',
      event: eventsConstants.CHECKOUT_CART_UPDATED,
      attrs: [
        {
          user_alias: {
            alias_name: 'checkout-abandom-cart',
            alias_label: email,
          },
        },
      ],
    })
    return { response: response.data.data, email }
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const postMFACode = async code => {
  const route = `users/mfa/validate`
  return UAA.post(route, { code })
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(laravelErrorHandler(error)))
}

const fetchMFACode = async () => {
  const route = `users/mfa/resend`
  return UAA.post(route, {})
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(laravelErrorHandler(error)))
}

export { fetchStatus, fetchTrackLeadAlias, loginUser, postMFACode, fetchMFACode }
